/*
 * Copyright (c) 2020. FINN Sp. z o.o.
 */

package pl.finn.forms

import io.kvision.modal.Alert
import io.kvision.pace.Pace
import io.kvision.remote.ServiceException
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Job
import kotlinx.coroutines.launch

var paceCounter = 0

fun CoroutineScope.launchWithProgress(block: suspend () -> Unit): Job {
  Pace.show()
  paceCounter++
  return launch {
    try {
      block()
      paceCounter--
      if (paceCounter <= 0) Pace.hide()
    } catch (e: ServiceException) {
      Pace.hide()
      Alert.show("Błąd", e.message)
    } catch (e: Exception) {
      paceCounter--
      if (paceCounter <= 0) Pace.hide()
      console.log(e)
      Alert.show("Błąd", "W trakcie wykonywania operacji wystąpił błąd!")
    }
  }
}

suspend fun <T> withProgress(block: suspend () -> T): T {
  Pace.show()
  paceCounter++
  return try {
    block()
  } finally {
    paceCounter--
    if (paceCounter <= 0) Pace.hide()
  }
}
